/* eslint-disable */
import { AddIcon, HamburgerIcon } from "@chakra-ui/icons";
import {
  AspectRatio,
  Box,
  Button,
  Drawer,
  DrawerBody,
  DrawerCloseButton,
  DrawerContent,
  DrawerOverlay,
  Flex,
  Icon,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalOverlay,
  Stack,
  Text,
  useColorModeValue,
  useDisclosure,
  useToken,
} from "@chakra-ui/react";
import IconBox from "components/Icons/IconBox";
import { Separator } from "components/Separator/Separator";
import React from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import InfoPanel from "./InfoPanel";
import { getTutorialVideo } from "constants/Tutorialvideos";
import { useDefaultShakhsSherkat } from "context/ShakhsContext";

const RELATED_LINK_GROUP = ["طرف حساب/خریدار", "کالا/خدمات", "صورتحساب ها"];

const isInRelatedGroup = (route) =>
  !route.redirect &&
  !route.separator &&
  RELATED_LINK_GROUP.includes((route.name || "").trim());

function SidebarResponsive(props) {
  const location = useLocation();
  const mainPanel = React.useRef();
  const btnRef = React.useRef();

  const activeColor = useColorModeValue("gray.700", "white");
  const groupBgColor = useColorModeValue("#39a499", "brand.600");
  let hamburgerColor = useColorModeValue("gray.500", "gray.200");

  // باید قبل از createLinks تعریف شود؛ چون renderLink از onClose استفاده می‌کند.
  const {
    isOpen: isDrawerOpen,
    onOpen: onDrawerOpen,
    onClose: onDrawerClose,
  } = useDisclosure();

  const {
    isOpen: isVideoOpen,
    onOpen: onVideoOpen,
    onClose: onVideoClose,
  } = useDisclosure();

  const [boxShadow] = useToken("colors", ["navbar_logout_button_shadow"]);
  const { defaultShakhs } = useDefaultShakhsSherkat();

  if (props.secondary === true) {
    hamburgerColor = "white";
  }

  const activeRoute = (routeName) =>
    location.pathname.includes(routeName) ? "active" : "";

  const renderCategoryLabel = (route) => (
    <Text
      color={activeColor}
      fontWeight="bold"
      ps="10px"
      py="10px"
      fontSize="sm"
    >
      {route.name}
    </Text>
  );

  const renderLink = (route) => {
    const isActive = activeRoute(route.path) === "active";

    return (
      <NavLink to={route.path} key={route.name} onClick={onDrawerClose}>
        <Button
          boxSize="initial"
          justifyContent="flex-start"
          alignItems="center"
          bg={isActive ? "sidebar_select_div" : "transparent"}
          mb="5px"
          py="10px"
          ps="10px"
          borderRadius="8px"
          mr={3}
          w="90%"
          _hover={
            isActive
              ? { bg: "sidebar_select_div" }
              : { bg: "sidebar_hover", color: "white" }
          }
          _active={{
            bg: "inherit",
            transform: "none",
            borderColor: "transparent",
          }}
          _focus={{ boxShadow: "none" }}
        >
          <Flex alignItems="center">
            {typeof route.icon === "string" ? (
              <Icon>{route.icon}</Icon>
            ) : (
              <IconBox
                bg={
                  isActive
                    ? "sidebar_select_icon_bg"
                    : "sidebar_unselect_icon_bg"
                }
                color={
                  isActive
                    ? "sidebar_select_icon_color"
                    : "sidebar_unselect_icon_color"
                }
                h="30px"
                w="30px"
                me="12px"
              >
                {route.icon}
              </IconBox>
            )}

            <Text
              color={isActive ? "sidebar_select_text" : "sidebar_unselect_text"}
              fontSize="sm"
            >
              {route.name}
            </Text>
          </Flex>
        </Button>
      </NavLink>
    );
  };

  const createLinks = (routes) => {
    const elements = [];
    let index = 0;

    while (index < routes.length) {
      const route = routes[index];

      if (route.redirect) {
        index += 1;
        continue;
      }

      if (route.separator) {
        elements.push(
          <Separator
            my={2}
            key={`separator-${index}`}
            hasTitle={route.separator}
          />,
        );
        index += 1;
        continue;
      }

      // گروه مرتبط با فرآیند صدور صورت‌حساب
      if (isInRelatedGroup(route)) {
        const groupItems = [];

        while (index < routes.length && isInRelatedGroup(routes[index])) {
          groupItems.push(routes[index]);
          index += 1;
        }

        elements.push(
          <Box
            key={`related-group-${groupItems
              .map((item) => item.name)
              .join("-")}`}
            boxShadow="0 2px 8px rgba(0, 0, 0, 0.15)"
            borderRadius="12px"
            p="8px"
            pl={0}
            mb="16px"
            bg={groupBgColor}
          >
            {groupItems.map((groupRoute) =>
              groupRoute.category ? (
                <Box key={groupRoute.name}>
                  {renderCategoryLabel(groupRoute)}
                  {createLinks(groupRoute.views)}
                </Box>
              ) : (
                renderLink(groupRoute)
              ),
            )}
          </Box>,
        );

        continue;
      }

      if (route.category) {
        elements.push(
          <Box key={route.name}>
            {renderCategoryLabel(route)}
            {createLinks(route.views)}
          </Box>,
        );

        index += 1;
        continue;
      }

      elements.push(renderLink(route));
      index += 1;
    }

    return elements;
  };

  const { routes } = props;
  const links = <>{createLinks(routes)}</>;
  const TUTORIAL_VIDEO_URL = getTutorialVideo(location.pathname);

  return (
    <Flex
      display={{ base: "flex", lg: "none" }}
      ref={mainPanel}
      gap={{base :3 , md:4}}
      alignItems="center"
    >
      <Button
        w={1}
        bg="infopanel_theme_bg"
        boxShadow={boxShadow}
        borderRadius={8}
        onClick={onDrawerOpen}
        ref={btnRef}
      >
        <HamburgerIcon color={hamburgerColor} w="20px" h="20px" />
      </Button>

      {defaultShakhs?.name && (
        <Text
          fontSize="sm"
          fontWeight="bold"
          color={activeColor}
          whiteSpace="nowrap"
          overflow="hidden"
          textOverflow="ellipsis"
          maxW="140px"
        >
          {defaultShakhs.name}
        </Text>
      )}

      {TUTORIAL_VIDEO_URL && (
        <Button
          fontSize="xs"
          ml={{ base: 2, md: 2 }}
          size="sm"
          bg="button_teal_bg"
          color="button_teal_color"
          _hover={{ bg: "button_teal_hover" }}
          colorScheme="teal"
          borderRadius="6px"
          onClick={onVideoOpen}
        >
          ویدیو آموزشی
        </Button>
      )}

      {TUTORIAL_VIDEO_URL && (
        <Modal
          isOpen={isVideoOpen}
          onClose={onVideoClose}
          size="6xl"
          isCentered
        >
          <ModalOverlay bg="blackAlpha.300" backdropFilter="blur(8px)" />

          <ModalContent bg="black" borderRadius="12px" overflow="hidden">
            <ModalCloseButton color="white" zIndex={1} />

            <ModalBody p={0}>
              <AspectRatio ratio={16 / 9}>
                <video
                  src={TUTORIAL_VIDEO_URL}
                  controls
                  autoPlay
                  style={{ width: "100%", height: "100%" }}
                >
                  این ویدیو توسط مرورگر شما پشتیبانی نمی‌شود
                </video>
              </AspectRatio>
            </ModalBody>
          </ModalContent>
        </Modal>
      )}

      <Drawer
        isOpen={isDrawerOpen}
        onClose={onDrawerClose}
        placement={document.documentElement.dir === "rtl" ? "right" : "left"}
        finalFocusRef={btnRef}
      >
        <DrawerOverlay backdropFilter="blur(5px)" bg="rgba(0,0,0,0.2)" />

        <DrawerContent w="300px" maxW="300px" bg="sidebar">
          

          <DrawerBody
            p={0}
            display="flex"
            flexDirection="column"
            overflow="hidden"
          >
            {/* InfoPanel همان بالا باقی می‌ماند */}
            <Box px={"1rem"}>
              <InfoPanel onCloseDrawer={onDrawerClose} />
            </Box>

            {/* فقط منوی لینک‌ها اسکرول می‌شود */}
            <Box flex="1" overflowY="auto" px="1rem" >
              <Stack direction="column" pb={4}>
                <Box>{links}</Box>
              </Stack>
            </Box>

            {/* دکمهٔ ثابت پایین Drawer موبایل */}
            <Flex
              w="full"
              justifyContent="center"
              alignItems="center"
              px="1rem"
              pb="1rem"
              pt={2}
            >
              <Button
                as={Link}
                to="/user/sodorhesab/add"
                onClick={onDrawerClose}
                position="relative"
                zIndex="1"
                overflow="hidden"
                justifyContent="center"
                alignItems="center"
                bg="brand.400"
                w="full"
                h="45px"
                borderRadius="6px"
                _hover={{
                  bg: "brand.300",
                  shadow: "lg",
                }}
                gap={2}
                sx={{
                  "&::before": {
                    content: '""',
                    position: "absolute",
                    top: 0,
                    left: "-75%",
                    width: "50%",
                    height: "100%",
                    background:
                      "linear-gradient(120deg, transparent, rgba(255,255,255,0.5), transparent)",
                    transform: "skewX(-20deg)",
                    animation: "buttonShine 1.2s ease-in-out infinite",
                    zIndex: 2,
                    pointerEvents: "none",
                  },
                  "@keyframes buttonShine": {
                    "0%": { left: "-75%" },
                    "50%": { left: "125%" },
                    "100%": { left: "125%" },
                  },
                }}
              >
                <AddIcon color="white" />
                <Text color="white" fontSize="sm">
                  صورتحساب جدید
                </Text>
              </Button>
            </Flex>
          </DrawerBody>
        </DrawerContent>
      </Drawer>
    </Flex>
  );
}

export default SidebarResponsive;